<template>
  <v-row>
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn outlined color="grey darken-2" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
              <app-modal-insert-meeting
                v-if="
                  isFullAdmin || (config.novoEvento && groupsConfig.novoEvento)
                "
                :dialog="dialog"
                :meetings="events"
                @onSave="getMeetings"
              ></app-modal-insert-meeting>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Diária</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semanal</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mensal</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>

      <!-- Legenda compacta dos tipos de encontro -->
      <v-sheet class="pa-2 mb-2" color="grey lighten-4" v-if="verTipoEncontro">
        <v-row align="center" justify="space-between">
          <v-col cols="auto">
            <v-row align="center" no-gutters>
              <v-col cols="auto" class="mr-2">
                <small class="text--secondary">Tipos de Encontro:</small>
              </v-col>
              <v-col cols="auto">
                <v-row align="center" no-gutters>
                  <v-col
                    v-for="tipo in tiposEncontro"
                    :key="tipo.encontrosTipoId"
                    cols="auto"
                    class="mr-4"
                  >
                    <v-menu
                      v-model="tipo.showColorPicker"
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="tipo.cor"
                          fab
                          x-small
                          v-bind="attrs"
                          v-on="on"
                          :style="`background-color: ${tipo.cor} !important; height: 25px; width: 25px; min-width: 25px;`"
                          class="mr-1"
                        >
                        </v-btn>
                      </template>
                      <v-color-picker
                        v-model="tipo.cor"
                        hide-mode-switch
                        hide-inputs
                        @update:color="
                          onColorChange(
                            tipo.encontrosTipoId,
                            $event,
                            tipo.encontrostipocoresid
                          )
                        "
                      ></v-color-picker>
                    </v-menu>
                    <small>{{ tipo.nome }}</small>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet height="600">
        <v-calendar
          locale="pt-BR"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :event-more-text="'Ver mais eventos'"
          :event-end="'fim'"
          :event-name="'nome'"
          :event-start="'inicio'"
          :now="today"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        >
        </v-calendar>

        <app-modal-edit-meeting
          :dialogEdicao="dialogEdicao"
          :payload="selectedEvent"
          :meetings="events"
          @onSave="getMeetings"
          @closeDialog="closeEdicaoDialog"
        >
        </app-modal-edit-meeting>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { meetingAPI } from "@/modules/calendar";
import { eventAPI } from "@/modules/event";
import AppModalInsertMeeting from "./ModalInsertMeeting";
import AppModalEditMeeting from "./ModalEditMeeting";
import moment from "moment";
import { encontrosTipoAPI, encontrosTipoCoresAPI } from "@/apis";
export default {
  components: {
    AppModalInsertMeeting,
    AppModalEditMeeting,
  },
  data() {
    return {
      municipioId: this.$route.params.id,
      focus: "",
      type: "month",
      typeToLabel: {
        month: "Mensal",
        week: "Semanal",
        day: "Diária",
      },
      start: null,
      end: null,
      selectedEvent: {
        nome: null,
        grupoId: 0,
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: [],
        convidadosEvento: [],
        duracaoString: this.duracao,
        novaTarefa: {},
        encontroType: "Parcial",
        encontrosTipoId: 1,
      },
      selectedElement: null,
      selectedOpen: false,
      encontrosTipo: [],
      events: [],
      today: null,
      date: null,
      time: null,
      dialog: false,
      dialogEdicao: false,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      // Configurações de cores para tipos de encontro
      showLegenda: false,
      tiposEncontro: [
        { encontrosTipoId: 1, nomeCor: "#2196F3", showColorPicker: false }, // Azul
        {
          encontrosTipoId: 2,
          nomeCor: "#4CAF50",
          showColorPicker: false,
        }, // Verde
        { encontrosTipoId: 3, nomeCor: "#FF9800", showColorPicker: false }, // Laranja
        {
          encontrosTipoId: 4,
          nomeCor: "#9E9E9E",
          showColorPicker: false,
        }, // Cinza
      ],
    };
  },
  computed: {
    ...mapGetters(["loading", "isFullAdmin", "isAT", "user"]),

    verTipoEncontro() {
      return this.config.verTipoEncontro && this.groupsConfig.verTipoEncontro;
    },

    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);
      const startYear = start.year;
      const startDay = start.day + this.nth(start.day);

      switch (this.type) {
        case "month":
          return `${startMonth} ${startYear}`;
        case "week":
        case "day":
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return "";
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long",
      });
    },
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.getMeetings();
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
    this.listEvents();
  },
  methods: {
    ...mapActions(["setLoading", "setAnalistaMunicipio", "setADMunicipio"]),
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      this.dialogEdicao = true;
      this.selectedEvent = {
        ...this.selectedEvent,
        ...event,
        duracaoString: this.duracao(event.inicioString, event.fimString),
      };
    },
    duracao(inicio, fim) {
      var diff = moment(fim, "DD/MM/YYYY HH:mm").diff(
        moment(inicio, "DD/MM/YYYY HH:mm"),
        "seconds"
      );

      diff = moment
        .utc(moment.duration(diff, "seconds").asMilliseconds())
        .format("HH:mm");

      return diff;
    },

    updateRange({ start, end }) {
      this.start = start;
      this.end = end;
    },
    nth(d) {
      return d > 3 && d < 21
        ? "th"
        : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
    },
    getMeetings() {
      this.setLoading(true);
      this.dialogEdicao = false;
      meetingAPI
        .getByCity(this.municipioId)
        .then((resp) => {
          this.events = resp.data;
          eventAPI
            .getByFilter({ municipioId: this.municipioId })
            .then((response) => {
              let meetings = response.data;
              for (let count = 0; count < meetings.length; count++) {
                this.events.push(meetings[count]);
              }
              this.setLoading(false);
            })
            .catch((response) => {
              this.setLoading(false);
              this.$notification.error("Erro ao buscar eventos");
            });
        })
        .catch((resp) => {
          this.setLoading(false);
          if (this.isAT) this.$notification.error("Erro ao buscar agendas");
          else this.$notification.error("Erro ao buscar encontros");
        });
    },
    closeEdicaoDialog() {
      this.selectedEvent = {
        nome: null,
        grupoId: 0,
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: [],
        convidadosEvento: [],
        duracaoString: this.duracao,
        novaTarefa: {},
        encontroType: "Parcial",
        encontrosTipoId: 1,
      };
      this.selectedElement = null;
      this.dialogEdicao = false;
    },
    listEvents() {
      encontrosTipoAPI
        .list()
        .then((tipoEncontro) => {
          encontrosTipoCoresAPI
            .listByUser(this.user.usuarioId)
            .then((tipoEncontrosCores) => {
              this.tiposEncontro = tipoEncontro.data.map((item) => {
                const tipoCor = tipoEncontrosCores.data.find(
                  (cor) => cor.encontrosTipoId === item.encontrosTipoId
                );

                const tipoCorDefault = this.tiposEncontro.find(
                  (t) => t.encontrosTipoId === item.encontrosTipoId
                );

                return {
                  ...item,
                  cor: tipoCor
                    ? tipoCor.nomeCor
                    : tipoCorDefault?.nomeCor || "#2196F3",
                  encontrostipocoresid: tipoCor
                    ? tipoCor.encontrostipocoresid
                    : null,
                  showColorPicker: false,
                };
              });
            })
            .catch();
        })
        .catch();
    },

    // Métodos para gerenciamento de cores dos tipos de encontro
    getEventColor(event) {
      // Se não tem permissão para ver tipos de encontro, retorna cor primária
      if (!this.verTipoEncontro) {
        return "#1976D2"; // Cor primária padrão do Vuetify
      }

      const tipo = this.tiposEncontro.find(
        (t) => t.encontrosTipoId === event.encontrosTipoId
      );
      return tipo ? tipo.cor : "#2196F3";
    },

    updateTipoColor(tipoId, newColor) {
      const tipo = this.tiposEncontro.find((t) => t.encontrosTipoId === tipoId);
      if (tipo) {
        tipo.cor = typeof newColor === "string" ? newColor : newColor.hex;
        this.saveCoresConfig();
      }
    },

    // Método para alterar cor e salvar automaticamente no backend
    async onColorChange(tipoId, newColor, encontrostipocoresid) {
      const colorValue = typeof newColor === "string" ? newColor : newColor.hex;

      // Atualiza visualmente a cor
      const tipo = this.tiposEncontro.find((t) => t.encontrosTipoId === tipoId);
      if (tipo) {
        tipo.cor = colorValue;
      }

      try {
        if (encontrostipocoresid) {
          await encontrosTipoCoresAPI.update({
            encontrosTipoId: tipoId,
            encontrostipocoresid: encontrostipocoresid,
            nomeCor: colorValue,
            usuarioId: this.user.usuarioId, // ou qualquer identificação necessária
          });
        } else {
          const response = await encontrosTipoCoresAPI.create({
            encontrosTipoId: tipoId,
            nomeCor: colorValue,
            usuarioId: this.user.usuarioId, // ou qualquer identificação necessária
          });

          // Armazena o encontrostipocoresid retornado da API no array tiposEncontro
          if (response.data && response.data.encontrosTipoCoresId) {
            const tipoIndex = this.tiposEncontro.findIndex(
              (t) => t.encontrosTipoId === tipoId
            );
            if (tipoIndex !== -1) {
              this.tiposEncontro[tipoIndex].encontrostipocoresid =
                response.data.encontrosTipoCoresId;
            }
          }
        }
      } catch (error) {
        console.error("Erro ao salvar cor no backend:", error);
        this.$notification.error("Erro ao salvar a cor. Tente novamente.");
      }
    },
  },
};
</script>
